import { presetCheckpoints, BASETYPE_NAME_TO_VALUE, MODEL_FLUX } from '@shakkerai/pro-models';
import React, { useRef, useState } from 'react';
import { translate } from '@shakkerai/util-i18n';
import { Icon } from '@shakkerai/components';
import { request } from '@shakkerai/services';
import { convert2CompressedUrl } from '@shakkerai/util-image';
import { useTempState, setTempState, useUnitData, getTempState } from '@starflow/app/store';
import styles from './index.module.scss';
import cx from 'classnames';
import { useAsyncEffect } from 'ahooks';
import { applyPresetModel } from '../../../../helpers';
import { useScrollTop } from '../../../../hooks/useScrollTop';

const PresetWrapper = ({ cols }) => {
  const [baseModelRunCount, setBaseModelRunCount] = useState();
  const { presetBaseModelId: unitPresetBaseModelId } = useUnitData();
  const tempPickingModel = useTempState('tempPickingModel');
  const tempCheckpoint = useTempState('tempCheckpoint');
  const ref = useRef(null);
  const { scroll } = useScrollTop(ref);

  const presetBaseModelId = tempPickingModel ? tempCheckpoint?.presetId : unitPresetBaseModelId;
  useAsyncEffect(async () => {
    const uuid = presetCheckpoints[0].versionDetail.uuid;
    try {
      const result = await request(`/api/www/img/tool/style/model/baseDetail/${uuid}`);
      if (result.code === 0) {
        setBaseModelRunCount(result.data.runCount);
      }
    } catch (err) {
      console.log('api error', err);
    }
  }, []);

  const handleApplyPresetModel = (item) => {
    if (getTempState('tempPickingModel')) {
      setTempState('tempCheckpoint', { presetId: item.id });
      getTempState('tempCheckpointPickCallback')?.({ presetId: item.id });
    } else {
      applyPresetModel(item.id);
    }
  };
  return (
    <div className="flex flex-wrap overflow-auto pl-4" ref={ref} onScroll={() => scroll()}>
      {presetCheckpoints.slice(0, 1).map((item) => {
        const using = presetBaseModelId === item.id;
        return (
          <div
            key={item.id}
            className="pr-4 pb-[18px]"
            style={{ width: `${(100 / cols) * 3}%`, aspectRatio: '590/250' }}
          >
            <div onClick={() => handleApplyPresetModel(item)} className={cx(styles['normal-gide-content'], 'h-full')}>
              <div className={cx('flex h-full ', styles['gid-content'], { [styles['gid-content-none']]: !using })}>
                <div
                  style={{ width: '31.2%', aspectRatio: '147/200' }}
                  className="bg-slate-600 relative rounded overflow-hidden"
                >
                  <img src={presetCheckpoints[0].imageVertical} className="w-full h-full" alt="" />
                  {baseModelRunCount > 0 ? (
                    <div className="h-5 w-full flex justify-center items-center absolute bottom-[20px] text-[#fff] text-sm font-normal not-italic">
                      <Icon
                        className="shk-danchuang-yunhangliang mr-1 relative top-[-1px]"
                        fontSize={12}
                        color="#fff"
                      />
                      <span>
                        {baseModelRunCount >= 1000 ? `${(baseModelRunCount / 1000).toFixed(1)}k` : baseModelRunCount}
                      </span>
                    </div>
                  ) : null}
                </div>
                <div className="flex-1 relative overflow-hidden">
                  {using ? (
                    <span
                      className={cx(
                        'text-[#2C2C2C] text-xs not-italic font-medium flex justify-center items-center pl-5 pr-4 h-[26px] absolute right-0 top-0',
                      )}
                    >
                      <div className="absolute top-0 -right-2 bg-primary w-20 h-[26px] rounded-bl-lg skew-x-12" />
                      <span className="relative z-[2]">{translate('preset_basemodle_using')}</span>
                    </span>
                  ) : null}
                  <div className="h-[70px]  flex items-center px-4">
                    <span className={cx('block', styles['gide-icon'])}>{translate('preset_basemodle_update')}</span>
                    <h5 className="text-[#2D2D2D] text-sm font-medium not-italic">
                      {translate('preset_basemodle_shakker')}
                    </h5>
                  </div>
                  <ul className="relative top-[-6px]">
                    <li className={styles['gide-single-line']}>
                      <i />
                      {translate('preset_basemodle_desc1')}
                    </li>
                    <li className={styles['gide-single-line']}>
                      <i />
                      {translate('preset_basemodle_desc2')}
                    </li>
                    <li className={styles['gide-single-line']}>
                      <i />
                      {translate('preset_basemodle_desc3')}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        );
      })}
      {presetCheckpoints.slice(1, presetCheckpoints.length).map((item) => {
        const using = presetBaseModelId === item.id;
        const itemBaseType = BASETYPE_NAME_TO_VALUE[item.baseType];
        return (
          <div key={item.id} style={{ width: `${100 / cols}%`, aspectRatio: '186/250' }} className="pr-4 pb-4">
            <div
              onClick={() => handleApplyPresetModel(item)}
              className={`h-full relative group bg-[#e4e6e8] overflow-hidden rounded cursor-pointer`}
            >
              {itemBaseType === MODEL_FLUX && globaoMode === 'pro' && (
                <span className="absolute z-[2] top-2 left-2 px-2 bg-black/60 rounded-[2px] text-white leading-[20px] text-xs">
                  {translate('model_flux_short')}
                </span>
              )}
              <img
                src={convert2CompressedUrl(item.imageUrl, 470)}
                className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition duration-500"
              />
              <div className="absolute w-full z-2 flex flex-col items-center justify-end pb-3 bg-gradient-to-b from-black/0 to-black/80 h-[72px] bottom-0">
                <span className="text-white text-xs font-semibold text-center">{item.displayName}</span>
                {using && <span className="mt-1 text-xs text-white/60">{translate('style_using')}</span>}
              </div>
              {using && <div className="absolute inset-0 z-3 border-2 border-primary rounded" />}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default PresetWrapper;
